import { ArchetypeDefinition } from '../../archetypeTypes';

export const CREATIVITY_ARCHETYPES: ArchetypeDefinition[] = [
    {
        key: 'creator',
        name: 'Creator',
        description: 'Imagination and constructive language shaping new patterns.',
        category: 'Creativity',
        tags: ['imagination', 'making', 'language'],
        weights: { linguisticComplexity: 0.45, energyLevel: 0.25, stability: 0.15, nodeCount: 0.15 }
    },
    {
        key: 'magician_creator',
        name: 'Magician-Creator',
        description: 'Transformative insight turning patterns into emergent forms.',
        category: 'Creativity',
        tags: ['transformation', 'insight', 'emergence'],
        weights: { fractalDimension: 0.35, linguisticComplexity: 0.25, energyLevel: 0.2, stability: 0.2 }
    },
    {
        key: 'artist',
        name: 'Artist',
        description: 'Expressive complexity with rhythmic/phonetic nuance.',
        category: 'Creativity',
        tags: ['expression', 'aesthetics', 'nuance'],
        weights: { linguisticComplexity: 0.35, voicePitch: 0.2, waveIntensity: 0.2, fractalDimension: 0.25 }
    }
];


